import { render, staticRenderFns } from "./VaccinatorDashboard.vue?vue&type=template&id=1f71728a&"
import script from "./VaccinatorDashboard.vue?vue&type=script&lang=js&"
export * from "./VaccinatorDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports